export default __webpack_public_path__ + "assets/icons/support_exchange.9e66362a.svg";